<template>
  <v-expand-transition>
    <div v-if="shouldDisplayErrors">
      <div
        class="errors-vincols multi-info-message"
        v-if="getBet.errors_multi_info.length > 0 && getBet.odds.length > 0"
      >
        <v-alert
          dense
          text
          type="error"
          v-for="(error, index) in getBet.errors_multi_info"
          :key="'error_info_multi_' + index"
          style="padding: 5px"
        >
          {{ $t(error.message) }}
        </v-alert>
      </div>

      <div
        class="errors-vincols"
        v-if="getBet.errors.length > 0 && getBet.odds.length > 0"
      >
        <v-alert
          dense
          text
          type="error"
          v-for="(error, index) in getBet.errors"
          :key="$uuid.v1()"
          style="padding: 5px"
        >
          {{
            error.message.includes('#')
              ? getErrorDesc(error.message)
              : $t(error.message)
          }}
          <br />
          <span
            v-if="
              error.message == 'minimumAmountNotRespected' ||
              error.message == 'maximumAmountNotRespected'
            "
            >{{ getSettings.currencySymbol }} {{ error.value }}</span
          >
        </v-alert>
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Errors',
  data: () => ({}),
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
    }),
    shouldDisplayErrors() {
      return (
        (this.getBet.errors_multi_info.length > 0 ||
          this.getBet.errors.length > 0) &&
        this.getBet.odds.length > 0
      )
    },
  },
  methods: {
    ...mapActions({}),
    getErrorDesc(message) {
      const split = message.split('#')
      return split[0] + ' ' + this.$t(split[1])
    },
  },
}
</script>
